/* eslint-disable no-nested-ternary */
import React, { useContext, useCallback, useState, useMemo } from 'react';
import classNames from 'classnames';
import Logo from './Logo';
import Wrapper from './Wrapper';
import SlideMenu from './SlideMenu';
import Search from './Search';
import LoginMenu from './LoginMenu';
import { Context } from '../../context/AppContext';
import useScrollPosition from '../../hooks/useScrollPosition';
import { MODALS } from '../../constants';
import OriginShine from '../../assets/misc/originstate-shine.svg';
import OriginBall from '../../assets/misc/originstate-ball.svg';
import './styles.css';

const { ADD_A_BUSINESS, REVIEW_FORM } = MODALS;

const Header = ({
  searchKeyword,
  searchLocation,
  showLocationInput,
  slideIn,
  defaultCategoryValue,
  showSearch,
  hideReview,
  stateOfOrigin,
  hideSearch,
  headerBottom,
  headerTransparent,
}) => {
  const {
    media: { desktop, tablet, mobile },
    modal: { showModal },
  } = useContext(Context);
  const [showHeader, setShowHeader] = useState(false);

  const links = [
    {
      text: 'Write a Review',
      onClick: () =>
        showModal(REVIEW_FORM, {
          disableDefaults: true,
        }),
      icon: <i className="icon-generalstarempty" />,
      show: desktop && !hideReview,
      className: 'Header__writeAReview',
    },
    {
      text: 'Add a Business',
      onClick: () => showModal(ADD_A_BUSINESS),
      icon: <i className="icon-generalwhatsonbrowse" />,
      show: desktop,
      className: 'Header__addABusiness',
    },
  ];

  const callback = useCallback(() => {
    setShowHeader(slideIn && window.scrollY > 44);
  }, [slideIn]);

  useScrollPosition(null, callback);

  const backgroundOverlay = useMemo(() => {
    if (stateOfOrigin && (stateOfOrigin === 'QLD' || stateOfOrigin === 'NSW')) {
      return OriginShine;
    }
    return null;
  }, [stateOfOrigin]);

  const stateOfOriginTitle = useMemo(() => {
    if (stateOfOrigin) {
      if (stateOfOrigin === 'NSW') {
        return (
          <div className="StateOfOrigin--title">
            <img src={OriginBall} alt="origin" />
            <p>
              GO <span>BLUES</span>
            </p>
          </div>
        );
      }
      if (stateOfOrigin === 'QLD') {
        return (
          <div className="StateOfOrigin--title">
            <img src={OriginBall} alt="origin" />
            <p>
              GO <span>MAROONS</span>
            </p>
          </div>
        );
      }
    }
    return null;
  }, [stateOfOrigin]);

  return (
    <Wrapper
      slideIn={slideIn}
      headerBottom={headerBottom}
      className={classNames({
        [`Header__StateOfOrigin Header__StateOfOrigin--${stateOfOrigin}`]: stateOfOrigin,
        'Header--backgroundOverlay': backgroundOverlay,
        'Header--headerTransparent': headerTransparent,
      })}
      style={
        backgroundOverlay
          ? {
              backgroundImage: `url(${backgroundOverlay})`,
            }
          : {}
      }
    >
      <div className="Header__left">
        <SlideMenu hideReview={hideReview} />
        <Logo small={mobile && showHeader && !hideSearch} mobile={mobile} />
        {!hideSearch &&
          (slideIn ? (
            showLocationInput || showSearch ? (
              <Search
                searchKeyword={searchKeyword}
                searchLocation={searchLocation}
                showLocationInput={showLocationInput}
                defaultCategoryValue={defaultCategoryValue}
              />
            ) : (
              showHeader && (
                <Search
                  defaultCategoryValue={defaultCategoryValue}
                  showLocationInput={showLocationInput}
                />
              )
            )
          ) : (
            <Search
              searchKeyword={searchKeyword}
              searchLocation={searchLocation}
              showLocationInput={showLocationInput}
              defaultCategoryValue={defaultCategoryValue}
            />
          ))}
      </div>
      {stateOfOriginTitle && (desktop || tablet) && (
        <div className="Header__center">{stateOfOriginTitle}</div>
      )}
      <div className="Header__right">
        {desktop &&
          links.map(item => {
            if (!item.show) return null;
            if (item.button)
              return (
                <div
                  key={item.button}
                  className={classNames('Header__link', {
                    [item.className]: item.className,
                  })}
                >
                  {item.button}
                </div>
              );
            return (
              <div
                key={item.text}
                className={classNames('Header__link', {
                  [item.className]: item.className,
                })}
              >
                <button
                  className="Header__link__button"
                  onClick={item.onClick}
                  type="button"
                >
                  {item.icon}
                  {item.text}
                </button>
              </div>
            );
          })}
      </div>
      <LoginMenu />
    </Wrapper>
  );
};

export default Header;
